import { useRouteMatch } from 'react-router-dom';

export const useIsJobDetail = () => {
  const { path } = useRouteMatch();
  return Boolean(path.includes('/jobs'));
};
